export default {
  dynamics: '{{change}} względem poprzedniego {{time_unit}}',
};
